/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function CheckedBox({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M4 2.6A1.4 1.4 0 0 0 2.6 4v8A1.4 1.4 0 0 0 4 13.4h8a1.4 1.4 0 0 0 1.4-1.4V8a.6.6 0 0 1 1.2 0v4a2.6 2.6 0 0 1-2.6 2.6H4A2.6 2.6 0 0 1 1.4 12V4A2.6 2.6 0 0 1 4 1.4h6a.6.6 0 1 1 0 1.2zm10.382-.062a.6.6 0 0 1 .08.844l-5.785 7a.6.6 0 0 1-.905.024l-3.214-3.5a.6.6 0 0 1 .884-.812L8.19 9.087l5.348-6.47a.6.6 0 0 1 .844-.08" clipRule="evenodd" /></svg>;
}
;